// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Dashboard from './pages/Dashboard';
import Favicon from './Favicon';
import Footer from './pages/components/Footer';

import SmoothScrolling from './pages/SmoothScrolling';


const App = () => {
  return (
    <SmoothScrolling>
      <Favicon />
      <div className="app-shell">
        <Router>
          <div className="app-content">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/dashboard" element={<Dashboard />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      </div>
    </SmoothScrolling>
  );
};

export default App;